<template>
  <div v-if="isOpen">
    <div class="filter-wrapper" @click="closeBlock"></div>

    <div class="filter-block" :class="{ active: selected }">
      <Datepicker v-model="selected.from" :format="'dd MM yyyy'" inline :disabled-dates="disabledFrom" class="range"
        :highlighted="emphasizedCell" />

      <Datepicker v-model="selected.to" :format="'dd MM yyyy'" inline :disabled-dates="disabledTo" class="range"
        :highlighted="emphasizedCell" />
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'filter-by-period',
  model: {
    prop: 'selected',
    event: 'change'
  },
  components: {
    Datepicker,
  },
  props: ['isOpen', 'selected', 'close'],
  methods: {
    closeBlock() {
      this.$emit('close')
    },
  },
  watch: {
    selected: {
      handler(value) {
        this.$emit('change', value)
      },

      deep: true,
    },

    'selected.from'(newValue, oldValue) {
      if (JSON.stringify(oldValue) === JSON.stringify(newValue)) {
        this.selected.from = null
      }
    },

    'selected.to'(newValue, oldValue) {
      if (JSON.stringify(oldValue) === JSON.stringify(newValue)) {
        this.selected.to = null
      }
    },

    // selected: {
    //   immediate: true,
    //   deep: true,

    //   handler(val) {
    //     if (JSON.stringify(val) != JSON.stringify(this.selected)) {
    //       this.selected = { ...val }
    //     }
    //   }
    // }
  },
  computed: {
    disabledFrom() {
      return {
        from: this.selected.to
      }
    },

    disabledTo() {
      return {
        to: this.selected.from
      }
    },

    emphasizedCell() {
      return {
        from: this.selected.from,
        to: this.selected.to
      }
    },

    // monthsList() {
    //   return [
    //     { value: '01', name: 'January' },
    //     { value: '02', name: 'February' },
    //     { value: '03', name: 'March' },
    //     { value: '04', name: 'April' },
    //     { value: '05', name: 'May' },
    //     { value: '06', name: 'June' },
    //     { value: '07', name: 'July' },
    //     { value: '08', name: 'August' },
    //     { value: '09', name: 'September' },
    //     { value: '10', name: 'October' },
    //     { value: '11', name: 'November' },
    //     { value: '12', name: 'December' },
    //   ]
    // },

    // yearsList() {
    //   const yearList = []

    //   for (let year = 2017; year <= new Date().getFullYear(); year++) {
    //     yearList.push(year)
    //   }

    //   return yearList
    // }
  }
}
</script>

<style lang="scss">
.vdp-datepicker.range {
  & .datepicker__clear-button {
    position: absolute;
  }

  & .vdp-datepicker__calendar {
    border: none;
    margin: 10px;
  }

  // & .cell.day {
  //   margin: 1px;
  // }

  & .cell.day.disabled {
    opacity: 0.4;
  }

  & .cell.day.highlighted {
    background: #E8FFE1;
  }

  & .cell.day.selected {
    background: #5DCF3C;
    border-radius: 8px;

    box-shadow: none;

    color: #fff !important
  }



}

.filter-wrapper {
  position: fixed;

  top: 0;
  bottom: 0;
  right: 0;
  left: 0;

  z-index: 4;
}

.filter-block {
  display: flex;
  position: absolute;

  top: 40px;
  right: 5px;

  padding: 10px;

  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);

  background-color: #fff;

  z-index: 5;

  justify-content: space-evenly;

  width: max-content;

  // height: 400px;

  & button {
    background-color: #fff;

    padding: 4px 8px;

    border-color: #B7AFBF;
    border-radius: 8px;
  }

  &.active button {
    border-color: #2795E2;
  }
}
</style>